import { TranslationProvider } from './hooks/use-translations';
import { SonosSoundsuitContent } from './pages/Sonos2025landing';
import { Routes, Route, Navigate } from 'react-router-dom';

function App() {
  return (
    <TranslationProvider>
      <Routes>
        <Route path='/' element={<SonosSoundsuitContent />} />
        <Route path='*' element={<Navigate to='/' replace />} />
      </Routes>
    </TranslationProvider>
  );
}

export default App;
